import { FC, useMemo } from "react";

import { CreateGUFClosureTask, EditGUFClosureTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GufClosureFormProps } from "@/types/form-types";

import { getGufClosureSchema } from "../schema/guf-closure-schema";
import { useGufClosureUiSchema } from "../schema/guf-closure-ui-schema";
import { validateGufClosureForm } from "../schema/guf-validation";

const GufClosureForm: FC<GufClosureFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { oldUploadTask, task, type } = getFormObjectValues(props);
  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    CreateGUFClosureTask | EditGUFClosureTask
  >({
    key: "guf-closure",
    task,
  });

  const uiSchema = useGufClosureUiSchema(formData?.metadata.qualityRegime);

  const schema = useMemo(() => getGufClosureSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGUFClosure(formData);
    } else {
      await api.createGUFClosure(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<CreateGUFClosureTask | EditGUFClosureTask>
      uploadTask={oldUploadTask}
      schema={schema}
      formData={formData}
      onChange={handleChange}
      uiSchema={uiSchema}
      onSubmit={onSubmit}
      customValidate={validateGufClosureForm}
    />
  );
};

export { GufClosureForm };
